import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { http } from "../../services/HttpInterceptor";
import { RouteComponentProps, Link, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { observable } from "mobx";
import InputForm from "../site/layout/InputForm";
import { sessionService } from "../../services/SessionService";
import DatePicker from "react-datepicker";

interface NewPaymentProps extends RouteComponentProps {
  changeToggle(action?: boolean): void;
}

const CONTRACT_STATUS_PAYMENT_WARNING = [
  "Pendiente Desconexion",
  "Pendiente Retiro",
];

@observer
export default class NewPayment extends React.Component<NewPaymentProps> {
  @observable private payment: any = {
    type: "",
    amount: "",
    invoice_id: "",
    date: new Date(),
    folio: "",
    card_id: "",
    paid_by: "",
    notes: "",
    picture_id: "",
    method: "",
    paid_at_office: 0,
  };

  @observable private date = new Date();
  @observable private remaining = "";
  @observable private redirect = false;
  @observable private antena = false;
  @observable private canContinue = false;
  @observable private cards = [];
  @observable private types = [
    { id: "Transferencia", name: "Transferencia" },
    { id: "Deposito", name: "Deposito" },
    { id: "Oficina", name: "Oficina" },
    { id: "Tecnico", name: "Tecnico" },
  ];
  @observable private validationErrors: string[] = ["type", "amount"];
  @observable private isLoaded: boolean = false;
  @observable private contractStatus: string = "";
  @observable private selectedFiles: File[] = [];
  @observable private previewUrls: string[] = [];
  @observable private uploadedPictureIds: string[] = [];
  @observable private isUploading: boolean = false;
  @observable private isSaving: boolean = false;
  private fileInput: HTMLInputElement | null = null;
  @observable private metodo_pago = [
    { id: "CREDITO", name: "Credito" },
    { id: "DEBITO", name: "Debito" },
    { id: "EFECTIVO", name: "Efectivo" },
  ];

  componentDidMount() {
    this.props.changeToggle(true);
    this.init();
  }

  componentWillUnmount() {
    // Limpiar URLs para evitar memory leaks
    this.previewUrls.forEach(url => URL.revokeObjectURL(url));
  }

  init = () => {
    const match = this.props.match;
    const id = (match as any).params.id;
    this.payment.invoice_id = id;
    http
      .get(`/api/payment/left/${id}`)
      .then((response) => {
        this.remaining = response.data;
        if (Number(this.remaining) < 0) {
          this.types.push({ id: "Antena", name: "Antena" });
          this.antena = true;
          this.payment.amount = this.remaining;
          this.payment.type = "Antena";
          this.validationErrors = [];
        }
      })
      .then(() => {
        return http.get(`/api/invoice/read/${id}`).then((response) => {
          return http
            .get(`/api/contract/read/${response.data.contract_id}`)
            .then((contractResponse) => {
              this.contractStatus = contractResponse.data.status || "";
            });
        });
      })
      .then(() => {
        http.get(`/api/card/read`).then((response) => {
          this.cards = response.data.response.filter(
            (card: any) => card.disabled === 0
          );
          this.isLoaded = true;
        });
      })
      .catch(() => {
        toast.error("Error cargando informacion del pago");
      });
  };

  private shouldShowContractStatusWarning = (): boolean => {
    return CONTRACT_STATUS_PAYMENT_WARNING.includes(this.contractStatus);
  };

  private handleChange = (event: any) => {
    const { name, value } = event.target;
    this.payment[name] = value;
    if (name === "type" && value !== "Oficina") {
      this.payment.method = "";
    }
  };

  private handleCheckboxChange = (event: any) => {
    const { name, checked } = event.target;
    this.payment[name] = checked ? 1 : 0;
  };

  private handleFileSelection = (files: File[]) => {
    // Limpiar URLs anteriores para evitar memory leaks
    this.previewUrls.forEach(url => URL.revokeObjectURL(url));
    
    // Agregar nuevos archivos a los existentes
    const newFiles = Array.from(files);
    const updatedFiles = [...this.selectedFiles, ...newFiles];
    
    // Crear URLs para los nuevos archivos
    const newUrls = newFiles.map(file => URL.createObjectURL(file));
    
    // Actualizar los arrays
    this.selectedFiles = updatedFiles;
    this.previewUrls = [...this.previewUrls, ...newUrls];
  };

  private removeFile = (index: number) => {
    // Revocar URL para evitar memory leak
    URL.revokeObjectURL(this.previewUrls[index]);
    
    // Remover archivo y URL
    const newFiles = this.selectedFiles.filter((_, i) => i !== index);
    const newUrls = this.previewUrls.filter((_, i) => i !== index);
    
    this.selectedFiles = newFiles;
    this.previewUrls = newUrls;
  };

  private clearAllFiles = () => {
    // Limpiar todas las URLs
    this.previewUrls.forEach(url => URL.revokeObjectURL(url));
    this.selectedFiles = [];
    this.previewUrls = [];
    this.uploadedPictureIds = [];
  };

  private uploadAllFiles = async (): Promise<void> => {
    if (this.selectedFiles.length === 0) {
      toast.error("No hay imágenes seleccionadas");
      return;
    }

    this.isUploading = true;
    const baseId = new Date().getTime().toString();

    try {
      // Crear FormData con todos los archivos
      const formData = new FormData();
      formData.append("id", baseId);
      
      // Agregar todos los archivos con el nombre 'files[]'
      this.selectedFiles.forEach((file, index) => {
        formData.append("files[]", file, file.name);
      });

      const response = await http.post("/api/payment/uploadImage", formData);
      const responseText = response.data || response;
      
      if (responseText.includes("Success:") || responseText.includes("subido(s) correctamente")) {
        // Generar los IDs basados en el baseId y la cantidad de archivos
        const uploadedIds = this.selectedFiles.map((_, index) => `${baseId}_${index}`);
        
        // Actualizar el payment con todos los IDs subidos
        this.uploadedPictureIds = [...this.uploadedPictureIds, ...uploadedIds];
        this.payment.picture_id = this.uploadedPictureIds.join(",");
        
        toast.success(`${this.selectedFiles.length} imagen(es) subida(s) con éxito`);
        this.canContinue = true;
        
        // Limpiar archivos seleccionados después de subir
        this.clearAllFiles();
      } else {
        throw new Error("Error en la respuesta del servidor");
      }
      
    } catch (error) {
      this.canContinue = false;
      console.error("Upload error:", error);
      throw error;
    } finally {
      this.isUploading = false;
    }
  };

  private setValidation = (value: boolean, name: string): void => {
    const error = this.validationErrors.indexOf(name);
    if (value && error === -1) {
      this.validationErrors.push(name);
    } else if (!value && error !== -1) {
      this.validationErrors.splice(error, 1);
    }
  };

  private onSubmit = async (): Promise<void> => {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    this.payment.created_by = sessionService.getUserInfo().id;

    this.payment.amount = this.payment.amount
      .replace("$", "")
      .replace(/,/g, "");

    this.payment.date = `${this.date.getFullYear()}-${(
      "0" +
      (this.date.getMonth() + 1)
    ).slice(-2)}-${("0" + this.date.getDate()).slice(-2)}`;

    if (this.validationErrors.length > 0) {
      this.isSaving = false;
      toast.error("Hay un error en tu formulario");
      return;
    }

    if (this.payment.type === "Oficina" && this.payment.method === "") {
      this.isSaving = false;
      toast.error("Debes elegir un metodo de pago");
      return;
    }

    if (this.selectedFiles.length > 0) {
      try {
        await this.uploadAllFiles();
        if (!this.canContinue) {
          throw new Error("Subida fallida");
        }
        this.createPayment();
      } catch {
        this.isSaving = false;
        toast.error("No se pudo subir las imágenes. Pago cancelado.");
      }
    } else if (!this.payment.picture_id) {
      this.isSaving = false;
      toast.error("Debes seleccionar al menos una imagen");
    } else {
      this.createPayment();
    }
  };

  private createPayment = () => {
    http
      .post(`/api/payment/create`, JSON.stringify(this.payment))
      .then(() => {
  
        // Guardar el estado para mostrar el mensaje después del redirect
        if (this.shouldShowContractStatusWarning()) {
          sessionStorage.setItem(
            "paymentStatusWarning",
            this.contractStatus
          );
        }
  
        toast.success("Pago agregado");
        this.redirect = true;
      })
      .catch((error) => {
        this.isSaving = false;
        if (Array.isArray(error)) {
          error.forEach((val) => {
            toast.error(val);
          });
        } else {
          toast.error(error);
        }
      });
  };

  setStartDate = (date: any) => {
    this.date = date;
  };

  render() {
    if (!this.isLoaded) {
      return null;
    }
    if (this.redirect) {
      return <Redirect to="/pagos" />;
    }
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header card-header-rose card-header-text">
                <div className="card-text">
                  <h4 className="card-title">Registrar un Pago</h4>
                </div>
              </div>
              <div className="card-body ">
                <div className="row">
                  <div className="col-sm-10"></div>
                  <div className="col-sm-2">
                    <Link to={`../pagos`}>
                      <button className="btn btn-danger btn-sm  pull-right">
                        <i className="material-icons">highlight_off</i>
                        <div className="ripple-container"></div>
                      </button>
                    </Link>
                  </div>
                </div>
                {this.shouldShowContractStatusWarning() && (
                  <div className="alert alert-warning" role="alert">
                    <i
                      className="material-icons"
                      style={{ verticalAlign: "middle", marginRight: "8px" }}
                    >
                      warning
                    </i>
                    Estás pagando un contrato con estatus:{" "}
                    <strong>{this.contractStatus}</strong>
                  </div>
                )}
                {this.payment.invoice_id && (
                  <InputForm
                    name="invoice_id"
                    label="Recibo #"
                    value={this.payment.invoice_id}
                    setValidation={this.setValidation}
                    required={false}
                    onChange={this.handleChange}
                    type="text"
                    disabled={true}
                  />
                )}
                <InputForm
                  name="remaining"
                  label="Cantidad pendiente de pagar"
                  value={this.remaining}
                  setValidation={this.setValidation}
                  required={true}
                  onChange={this.handleChange}
                  type="number"
                  prefix="$"
                  decimal={2}
                  thousandSeparator={true}
                  disabled={true}
                />
                <InputForm
                  name="amount"
                  label="Cantidad recibida"
                  value={this.payment.amount}
                  setValidation={this.setValidation}
                  required={true}
                  onChange={this.handleChange}
                  type="number"
                  prefix="$"
                  decimal={2}
                  thousandSeparator={true}
                  disabled={Number(this.remaining) < 0}
                />
                <InputForm
                  name="type"
                  label="Tipo de pago"
                  value={this.payment.type}
                  setValidation={this.setValidation}
                  required={true}
                  onChange={this.handleChange}
                  options={this.types}
                  disabled={Number(this.remaining) < 0}
                  type="select"
                />
                {this.payment.type === "Oficina" && (
                  <Fragment>
                    <InputForm
                      name="method"
                      label="Metodo de pago"
                      value={this.payment.method}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      options={this.metodo_pago}
                      type="select"
                    />
                  </Fragment>
                )}

                {this.payment.type !== "Oficina" &&
                  this.payment.type !== "Antena" &&
                  this.payment.type !== "Tecnico" && (
                    <Fragment>
                      <InputForm
                        name="folio"
                        label="Folio"
                        value={this.payment.folio}
                        setValidation={this.setValidation}
                        required={true}
                        onChange={this.handleChange}
                        type="text"
                        disabled={false}
                      />
                      <InputForm
                        name="card_id"
                        label="Tarjeta"
                        value={this.payment.card_id}
                        setValidation={this.setValidation}
                        required={true}
                        onChange={this.handleChange}
                        options={this.cards}
                        type="select"
                      />
                    </Fragment>
                  )}
                {this.payment.type === "Tecnico" && (
                  <InputForm
                    name="paid_by"
                    label="Nombre del Tecnico"
                    value={this.payment.paid_by}
                    setValidation={this.setValidation}
                    required={true}
                    onChange={this.handleChange}
                    type="text"
                    disabled={false}
                  />
                )}
                <div className="row">
                  <label className="col-sm-2 col-form-label">
                    Pago en oficina
                  </label>
                  <div className="col-sm-10">
                    <div className="form-group bmd-form-group">
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            className="form-check-input"
                            name="paid_at_office"
                            type="checkbox"
                            checked={this.payment.paid_at_office === 1}
                            onChange={this.handleCheckboxChange}
                          />
                          El pago se realizó en oficina
                          <span className="form-check-sign">
                            <span className="check"></span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-2 col-form-label">
                    Fecha de pago
                  </label>
                  <div className="col-sm-10">
                    <div className="form-group bmd-form-group is-filled">
                      <DatePicker
                        selected={this.date}
                        onChange={(date) => this.setStartDate(date)}
                      />
                    </div>
                  </div>
                </div>
                <InputForm
                  name="notes"
                  label="Notas (Max: 255 caracteres)"
                  value={this.payment.notes}
                  setValidation={this.setValidation}
                  required={false}
                  onChange={this.handleChange}
                  type="textarea"
                  maxLength={255}
                />
                <div className="row">
                  <label className="col-sm-2 col-form-label">
                    Imágenes del pago
                  </label>
                  <div className="col-sm-10">
                    <div className="form-group bmd-form-group">
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={(e) => this.handleFileSelection(Array.from(e.target.files || []))}
                        ref={(input) => { this.fileInput = input; }}
                        style={{ display: 'none' }}
                        id="file-input"
                      />
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => this.fileInput && this.fileInput.click()}
                        style={{ marginBottom: '10px' }}
                      >
                        <i className="material-icons" style={{ fontSize: '16px', marginRight: '5px' }}>add_photo_alternate</i>
                        Seleccionar Imágenes
                      </button>
                      <small className="form-text text-muted" style={{ display: 'block', marginTop: '5px' }}>
                        Selecciona una o múltiples imágenes (JPG, JPEG). Máximo 10MB por imagen.
                      </small>
                    </div>
                  </div>
                </div>
                
                {this.previewUrls.length > 0 && (
                  <div className="row">
                    <div className="col-sm-2"></div>
                    <div className="col-sm-10">
                      <div className="preview-container" style={{ marginBottom: '15px' }}>
                        <h6>Vista previa de las imágenes:</h6>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                          {this.previewUrls.map((url, idx) => (
                            <div key={idx} style={{ position: 'relative', display: 'inline-block' }}>
                              <img 
                                src={url} 
                                alt={`preview-${idx}`} 
                                style={{ 
                                  width: '100px', 
                                  height: '100px', 
                                  objectFit: 'cover',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px'
                                }} 
                              />
                              <div style={{ 
                                position: 'absolute', 
                                top: '2px', 
                                right: '2px',
                                background: 'rgba(0,0,0,0.7)',
                                color: 'white',
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                cursor: 'pointer'
                              }}
                              onClick={() => this.removeFile(idx)}
                              title="Eliminar imagen"
                              >
                                ×
                              </div>
                            </div>
                          ))}
                        </div>
                        <div style={{ marginTop: '10px' }}>
                          <button
                            onClick={this.uploadAllFiles}
                            type="button"
                            className="btn btn-success btn-sm"
                            disabled={this.isUploading}
                            style={{ marginRight: '10px' }}
                          >
                            <i className="material-icons" style={{ fontSize: '16px', marginRight: '5px' }}>
                              {this.isUploading ? 'hourglass_empty' : 'cloud_upload'}
                            </i>
                            {this.isUploading ? 'Subiendo...' : `Subir ${this.selectedFiles.length} Imagen(es)`}
                          </button>
                          <button
                            onClick={this.clearAllFiles}
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            disabled={this.isUploading}
                          >
                            <i className="material-icons" style={{ fontSize: '16px', marginRight: '5px' }}>clear_all</i>
                            Limpiar Todo
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <button
                  onClick={this.onSubmit}
                  type="button"
                  className="btn btn-primary pull-right"
                  disabled={this.isSaving}
                >
                  {this.isSaving ? "Procesando pago..." : "Agregar Pago"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
